<template>
  <div class="mian_index">
    <!-- 定向装备 -->
    <!--<z-equip :dxzb="dxzb"></z-equip>-->
    <!--最新咨询-->
    <z-infor :zxzx="zxzx"></z-infor>
    <!-- 定向动态 -->
    <z-dynamic :dxdt="dxdt"></z-dynamic>
    <!-- 定向风采 -->
    <z-mien :dxfc="dxfc" @onChangeCls="onChangeCls"></z-mien>
    <div class="clear margin_bottom"></div>
    <!-- 活动赛事 -->
    <z-game :hdss="hdss"></z-game>
    <!-- 教研培训 -->
    <z-train :jypx="jypx"></z-train>
    <div class="clear"></div>
  </div>
</template>

<script>
import equip from '@/components/main/equip'
import infor from '@/components/main/infor'
import dynamic from '@/components/main/dynamic'
import mien from '@/components/main/mien'
import game from '@/components/main/game'
import train from '@/components/main/train'
export default {
  name: 'mianIndex',
  components: {
    'z-equip': equip,
    'z-infor': infor,
    'z-dynamic': dynamic,
    'z-mien': mien,
    'z-game': game,
    'z-train': train
  },
  data () {
    return {
      dxdt: [], // 定向动态
      zxzx: [], // 最新咨询
      dxfc: [], // 定向风采
      jsfc: [], // 教师风采
      xxfc: [], // 学校风采
      hdss: [], // 活动赛事
      jypx: [] // 教研培训
    }
  },
  created () {
  },
  mounted () {
    this.loadHomePage()
  },
  computed: {},
  methods: {
    onChangeCls (cls) {
      this.dxfc = cls === 5 ? this.jsfc : this.xxfc
    },
    loadHomePage () {
      this.$axios.homePage().then(res => {
        if (res) {
          let data = res.data.data
          this.zxzx = data.zxzx
          this.dxfc = data.jsfc
          this.jsfc = data.jsfc
          this.xxfc = data.xxfc
          this.dxdt = data.dxdt
          this.hdss = data.hdss
          this.jypx = data.jypx
        }
      })
    }
  },
  watch: {}
}
</script>

<style scoped>
  .mian_index {height: 100%;}
  .mian_index .margin_bottom {margin-bottom: 20px;}
</style>



// WEBPACK FOOTER //
// src/pages/main/index.vue